"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("@seedlang/utils");
var _serializr = require("serializr");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _lodash = require("lodash");
var _mobx = require("mobx");
var _campaign = _interopRequireDefault(require("./campaign"));
var _custom_tab = _interopRequireDefault(require("./custom_tab"));
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _download_link = _interopRequireDefault(require("./download_link"));
var _exercise = _interopRequireDefault(require("./exercise"));
var _file = _interopRequireDefault(require("./file"));
var _forum_thread = _interopRequireDefault(require("./forum_thread"));
var _grid_item_basic = _interopRequireDefault(require("./grid_item_basic"));
var _image = _interopRequireDefault(require("./image"));
var _podcast_episode = _interopRequireDefault(require("./podcast_episode"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _tag = _interopRequireDefault(require("./tag"));
var _worksheet_membership_type = _interopRequireDefault(require("./worksheet_membership_type"));
var _worksheet_tag = _interopRequireDefault(require("./worksheet_tag"));
var _worksheet_word = _interopRequireDefault(require("./worksheet_word"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Worksheet = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_file["default"])), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_image["default"])), _dec3 = (0, _serializr.serializable)((0, _serializr.object)(_podcast_episode["default"])), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_campaign["default"])), _dec5 = (0, _serializr.serializable)((0, _serializr.object)(_forum_thread["default"])), _dec6 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return (0, _utils.isPresent)(item) ? new _date_decorator["default"](item) : null;
})), _dec7 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return (0, _utils.isPresent)(item) ? new _date_decorator["default"](item) : null;
})), _dec8 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_exercise["default"]))), _dec9 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_worksheet_word["default"]))), _dec10 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_grid_item_basic["default"]))), _dec11 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_worksheet_tag["default"]))), _dec12 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_worksheet_membership_type["default"]))), _dec13 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_tag["default"]))), _dec14 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_download_link["default"]))), _dec15 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_custom_tab["default"]))), _dec16 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _class = /*#__PURE__*/function (_RootModel) {
  function Worksheet() {
    var _this;
    _classCallCheck(this, Worksheet);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Worksheet, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "name", _descriptor2, _this);
    _initializerDefineProperty(_this, "published", _descriptor3, _this);
    _initializerDefineProperty(_this, "archived", _descriptor4, _this);
    _initializerDefineProperty(_this, "youtubeUrl", _descriptor5, _this);
    _initializerDefineProperty(_this, "pdfUrl", _descriptor6, _this);
    _initializerDefineProperty(_this, "worksheetId", _descriptor7, _this);
    _initializerDefineProperty(_this, "groupId", _descriptor8, _this);
    _initializerDefineProperty(_this, "exerciseEntriesCount", _descriptor9, _this);
    _initializerDefineProperty(_this, "userWorksheetsCount", _descriptor10, _this);
    _initializerDefineProperty(_this, "jsonCacheUrl", _descriptor11, _this);
    _initializerDefineProperty(_this, "correctAnswersCount", _descriptor12, _this);
    _initializerDefineProperty(_this, "overrideCompleted", _descriptor13, _this);
    _initializerDefineProperty(_this, "hasUserWorksheet", _descriptor14, _this);
    _initializerDefineProperty(_this, "usersStartedCount", _descriptor15, _this);
    _initializerDefineProperty(_this, "usersFinishedCount", _descriptor16, _this);
    _initializerDefineProperty(_this, "publishWords", _descriptor17, _this);
    _initializerDefineProperty(_this, "unprocessedVocab", _descriptor18, _this);
    _initializerDefineProperty(_this, "publishUnprocessedVocab", _descriptor19, _this);
    _initializerDefineProperty(_this, "accessWithoutMembership", _descriptor20, _this);
    _initializerDefineProperty(_this, "pinned", _descriptor21, _this);
    _initializerDefineProperty(_this, "transcript1Link", _descriptor22, _this);
    _initializerDefineProperty(_this, "transcript2Link", _descriptor23, _this);
    _initializerDefineProperty(_this, "transcript3Link", _descriptor24, _this);
    _initializerDefineProperty(_this, "downloadLink1", _descriptor25, _this);
    _initializerDefineProperty(_this, "downloadLink2", _descriptor26, _this);
    _initializerDefineProperty(_this, "downloadLink3", _descriptor27, _this);
    _initializerDefineProperty(_this, "downloadLink4", _descriptor28, _this);
    _initializerDefineProperty(_this, "downloadLink5", _descriptor29, _this);
    _initializerDefineProperty(_this, "downloadLink6", _descriptor30, _this);
    _initializerDefineProperty(_this, "forumThreadId", _descriptor31, _this);
    _initializerDefineProperty(_this, "filteredWorksheetsCount", _descriptor32, _this);
    _initializerDefineProperty(_this, "worksheetWordsCount", _descriptor33, _this);
    _initializerDefineProperty(_this, "positionsAreChronological", _descriptor34, _this);
    _initializerDefineProperty(_this, "description", _descriptor35, _this);
    _initializerDefineProperty(_this, "pdfContainsVocab", _descriptor36, _this);
    _initializerDefineProperty(_this, "pdfContainsExercises", _descriptor37, _this);
    _initializerDefineProperty(_this, "tagsCount", _descriptor38, _this);
    _initializerDefineProperty(_this, "downloadLinksCount", _descriptor39, _this);
    _initializerDefineProperty(_this, "skipNotification", _descriptor40, _this);
    _initializerDefineProperty(_this, "previewText", _descriptor41, _this);
    _initializerDefineProperty(_this, "hideYoutubeThumbnail", _descriptor42, _this);
    _initializerDefineProperty(_this, "pdf", _descriptor43, _this);
    _initializerDefineProperty(_this, "image", _descriptor44, _this);
    _initializerDefineProperty(_this, "podcastEpisode", _descriptor45, _this);
    _initializerDefineProperty(_this, "campaign", _descriptor46, _this);
    _initializerDefineProperty(_this, "forumThread", _descriptor47, _this);
    _initializerDefineProperty(_this, "publishedAt", _descriptor48, _this);
    _initializerDefineProperty(_this, "contentPublishedAt", _descriptor49, _this);
    _initializerDefineProperty(_this, "exercises", _descriptor50, _this);
    // @observable @serializable(list(object(Word))) words = [];
    _initializerDefineProperty(_this, "worksheetWords", _descriptor51, _this);
    _initializerDefineProperty(_this, "gridItems", _descriptor52, _this);
    _initializerDefineProperty(_this, "worksheetTags", _descriptor53, _this);
    _initializerDefineProperty(_this, "worksheetMembershipTypes", _descriptor54, _this);
    _initializerDefineProperty(_this, "tags", _descriptor55, _this);
    _initializerDefineProperty(_this, "downloadLinks", _descriptor56, _this);
    _initializerDefineProperty(_this, "customTabs", _descriptor57, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor58, _this);
    return _this;
  }
  _inherits(Worksheet, _RootModel);
  return _createClass(Worksheet, [{
    key: "hasForumThread",
    get: function get() {
      return (0, _utils.isPresent)(this.forumThread);
    }
  }, {
    key: "hasPdf",
    get: function get() {
      return (0, _utils.isPresent)(this.pdf) && (0, _utils.isPresent)(this.pdf.id) || (0, _utils.isPresent)(this.pdfUrl);
    }
  }, {
    key: "hasTranscripts",
    get: function get() {
      return (0, _utils.isPresent)(this.transcript1Link) || (0, _utils.isPresent)(this.transcript2Link) || (0, _utils.isPresent)(this.transcript3Link) || (0, _utils.isPresent)(this.downloadLink1) || (0, _utils.isPresent)(this.downloadLink2) || (0, _utils.isPresent)(this.downloadLink3) || (0, _utils.isPresent)(this.downloadLink4) || (0, _utils.isPresent)(this.downloadLink5) || (0, _utils.isPresent)(this.downloadLink6);
    }
  }, {
    key: "truncatedName",
    value: function truncatedName() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
      if (this.name.length <= length) return this.name;
      return "".concat(this.name.substring(0, length), "...");
    }
  }, {
    key: "youtubeVideoId",
    get: function get() {
      // also in worksheet_basic.js
      if ((0, _utils.isPresent)(this.youtubeUrl) && this.youtubeUrl.match('watch')) {
        var regexp = /watch\?v=(...........)/g;
        var match = regexp.exec(this.youtubeUrl);
        if (match) {
          return match[1];
        }
      }
    }
  }, {
    key: "imageUrl",
    get: function get() {
      // also in worksheet_basic.js
      if ((0, _utils.isPresent)(this.image)) {
        return this.image.url;
      }
      if (!this.hideYoutubeThumbnail && (0, _utils.isPresent)(this.youtubeThumbnailUrl)) {
        return this.youtubeThumbnailUrl;
      }
    }
  }, {
    key: "youtubeThumbnailUrl",
    get: function get() {
      // also in worksheet_basic.js
      if ((0, _utils.isPresent)(this.youtubeVideoId) && !this.hideYoutubeThumbnail) {
        return "http://img.youtube.com/vi/".concat(this.youtubeVideoId, "/maxresdefault.jpg");
      }
    }
  }, {
    key: "formattedYoutubeUrl",
    get: function get() {
      if ((0, _utils.isPresent)(this.youtubeUrl) && this.youtubeUrl.match('watch') && (0, _utils.isPresent)(this.youtubeVideoId)) {
        return "https://www.youtube.com/embed/".concat(this.youtubeVideoId);
      } else {
        return this.youtubeUrl;
      }
    }
  }, {
    key: "publishedAtDate",
    get: function get() {
      return this.publishedAt ? this.publishedAt.formattedDateWithYear : null;
    }
  }, {
    key: "nameWithPublished",
    get: function get() {
      var _this$site;
      if ((_this$site = this.site) !== null && _this$site !== void 0 && _this$site.isDefault) {
        return this.published ? this.name : "".concat(this.nameWithoutEpisodeCode, " (unpublished)");
      }
      return this.published ? this.nameWithoutEpisodeCode : "".concat(this.nameWithoutEpisodeCode, " (unpublished)");
    }
  }, {
    key: "nameWithoutEpisodeCode",
    get: function get() {
      if ((0, _utils.isPresent)(this.podcastEpisode)) {
        return this.name;
      }
      return this.name.replace(/\s\([A-Z]+\s?\d+\)$/, '');
    }
  }, {
    key: "episodeCode",
    get: function get() {
      if ((0, _utils.isPresent)(this.podcastEpisode)) {
        return;
      }
      return this.name.replace(this.nameWithoutEpisodeCode, '').replace(/(^\s*\(|\)$)/gm, '').trim();
    }
  }, {
    key: "isNew",
    get: function get() {
      var _this$publishedAt;
      if ((0, _utils.isPresent)((_this$publishedAt = this.publishedAt) === null || _this$publishedAt === void 0 ? void 0 : _this$publishedAt.date)) {
        var _this$publishedAt2;
        var currentDate = new Date();
        var timeDiff = currentDate - ((_this$publishedAt2 = this.publishedAt) === null || _this$publishedAt2 === void 0 ? void 0 : _this$publishedAt2.date);
        var daysDiff = timeDiff / (1000 * 60 * 60 * 24);
        return daysDiff < 7 && !this.hasUserWorksheet; // published in the last 7 days
      }
      return false;
    }
  }, {
    key: "hasContent",
    get: function get() {
      var _this$site2, _this$forumThread;
      return !this.hasNoPublishedVocab && !this.hasUnpublishedVocab || this.downloadLinksCount > 0 || (0, _utils.isPresent)(this.pdfUrl) || this.exerciseEntriesCount > 0 || ((_this$site2 = this.site) === null || _this$site2 === void 0 ? void 0 : _this$site2.showWorksheetComments) && !((_this$forumThread = this.forumThread) !== null && _this$forumThread !== void 0 && _this$forumThread.hidden);
    }
  }, {
    key: "isValid",
    get: function get() {
      // also in worksheet.rb
      return this.hasContent && (this.youtubeUrlIsValid || (0, _utils.isPresent)(this.podcastEpisode)) && ((0, _utils.isPresent)(this.imageUrl) || (0, _utils.isPresent)(this.previewText)) && (0, _utils.isPresent)(this.description);
    }
  }, {
    key: "youtubeUrlIsValid",
    get: function get() {
      return (0, _utils.isPresent)(this.youtubeUrl) && this.youtubeUrl.startsWith('https://www.youtube.com/watch?v=');
    }
  }, {
    key: "hasUnpublishedVocab",
    get: function get() {
      return this.worksheetWordsCount > 0 && !this.publishWords || (0, _utils.isPresent)(this.unprocessedVocab) && !this.publishUnprocessedVocab;
    }
  }, {
    key: "hasPublishedVocab",
    get: function get() {
      return this.worksheetWordsCount > 0 && this.publishWords || (0, _utils.isPresent)(this.unprocessedVocab) && this.publishUnprocessedVocab;
    }
  }, {
    key: "hasNoPublishedVocab",
    get: function get() {
      return (this.worksheetWordsCount === 0 || !this.publishWords) && ((0, _utils.isBlank)(this.unprocessedVocab) || !this.publishUnprocessedVocab);
    }
  }, {
    key: "membershipTypeNames",
    get: function get() {
      var _this$worksheetMember;
      return (_this$worksheetMember = this.worksheetMembershipTypes) === null || _this$worksheetMember === void 0 ? void 0 : _this$worksheetMember.map(function (item) {
        var _item$membershipType;
        return (_item$membershipType = item.membershipType) === null || _item$membershipType === void 0 ? void 0 : _item$membershipType.name;
      }).join(', ');
    }
  }, {
    key: "contentPublishedOnADifferentDay",
    get: function get() {
      if ((0, _utils.isBlank)(this.publishedAt) || (0, _utils.isBlank)(this.contentPublishedAt)) return false;
      return Math.abs(this.publishedAt.date - this.contentPublishedAt.date) / 3600000 > 24;
    }
  }, {
    key: "contentType",
    get: function get() {
      if (this.podcastEpisode) {
        return 'podcast';
      }
      return 'video';
    }
  }, {
    key: "orderedTags",
    get: function get() {
      return (0, _lodash.orderBy)(this.worksheetTags, ['tag.overallPosition']).map(function (item) {
        return item.tag;
      });
    }
  }, {
    key: "levelTags",
    get: function get() {
      return this.orderedTags.filter(function (item) {
        return item.level;
      });
    }
  }, {
    key: "levelTagsFormatted",
    get: function get() {
      if (this.levelTags && this.levelTags.length > 1) {
        return "".concat((0, _lodash.first)(this.levelTags).name, "-").concat((0, _lodash.last)(this.levelTags).name);
      }
      return this.levelTags.map(function (item) {
        return item.name;
      }).join(', ');
    }
  }, {
    key: "tagsForRouteName",
    value: function tagsForRouteName(routeName) {
      if ((0, _utils.isBlank)(this.orderedTags)) return [];
      if (routeName === 'videos.index') {
        return this.orderedTags.filter(function (item) {
          return item.displayOnVideoWorksheets;
        });
      } else if (routeName === 'podcasts.index') {
        return this.orderedTags.filter(function (item) {
          return item.displayOnPodcastWorksheets;
        });
      }
      return this.orderedTags;
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "published", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "archived", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "youtubeUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "pdfUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "worksheetId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "groupId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "exerciseEntriesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "userWorksheetsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "jsonCacheUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "correctAnswersCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "overrideCompleted", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "hasUserWorksheet", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "usersStartedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "usersFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "publishWords", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "unprocessedVocab", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "publishUnprocessedVocab", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "accessWithoutMembership", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "pinned", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "transcript1Link", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "transcript2Link", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "transcript3Link", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "downloadLink1", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "downloadLink2", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "downloadLink3", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "downloadLink4", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "downloadLink5", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "downloadLink6", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "forumThreadId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "filteredWorksheetsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "worksheetWordsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "positionsAreChronological", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "description", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "pdfContainsVocab", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "pdfContainsExercises", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "tagsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "downloadLinksCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "skipNotification", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "previewText", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "hideYoutubeThumbnail", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "pdf", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "image", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "podcastEpisode", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "campaign", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "forumThread", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "publishedAt", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "contentPublishedAt", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "exercises", [_mobx.observable, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "worksheetWords", [_mobx.observable, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "gridItems", [_mobx.observable, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "worksheetTags", [_mobx.observable, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "worksheetMembershipTypes", [_mobx.observable, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "tags", [_mobx.observable, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "downloadLinks", [_mobx.observable, _dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "customTabs", [_mobx.observable, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "hasForumThread", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasForumThread"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasPdf", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasPdf"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasTranscripts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasTranscripts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "truncatedName", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "truncatedName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "youtubeVideoId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "youtubeVideoId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "youtubeThumbnailUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "youtubeThumbnailUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedYoutubeUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "formattedYoutubeUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "publishedAtDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "publishedAtDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nameWithPublished", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nameWithPublished"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nameWithoutEpisodeCode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nameWithoutEpisodeCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "episodeCode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "episodeCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNew", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNew"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasContent", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasContent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "youtubeUrlIsValid", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "youtubeUrlIsValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasUnpublishedVocab", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasUnpublishedVocab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasPublishedVocab", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasPublishedVocab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasNoPublishedVocab", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasNoPublishedVocab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "membershipTypeNames", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "membershipTypeNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentPublishedOnADifferentDay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contentPublishedOnADifferentDay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contentType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contentType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderedTags", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderedTags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "levelTags", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "levelTags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "levelTagsFormatted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "levelTagsFormatted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tagsForRouteName", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "tagsForRouteName"), _class.prototype), _class);
var _default = exports["default"] = Worksheet;